export default __webpack_public_path__ + "static/media/1-min.f713440a.jpg";